import { jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ControlValue } from "./control";
function ListControlValue({
  definition,
  data,
  children,
  control
}) {
  const [controls, setControls] = useState(/* @__PURE__ */ new Map());
  useEffect(() => {
    if (control == null || data == null)
      return;
    setControls(control.setItemsControl(data));
  }, [data, control]);
  return (data ?? []).reduce(
    (renderFn, item) => (listControlValue) => /* @__PURE__ */ jsx(
      ControlValue,
      {
        definition: definition.config.type,
        data: item.value,
        control: controls?.get(item.id),
        children: (value) => renderFn([value, ...listControlValue])
      }
    ),
    children
  )([]);
}
export {
  ListControlValue
};
//# sourceMappingURL=list.js.map